import { useCallback } from "react";

import { useAsyncCall } from "hooks";

function useTokenize(cbInstanceRef) {
  const [call, submitting] = useAsyncCall();

  const createToken = useCallback(
    async (additionalData = {}) => {
      return call(() => {
        return cbInstanceRef.current.tokenize(additionalData);
      });
    },
    [call, cbInstanceRef]
  );

  return [createToken, submitting];
}

export default useTokenize;
